const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  SIGNUP: "/signup",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password/:token",
  ACTIVATION: "/user/activate/:token",
  CUSTOMER_DASHBOARD: "/customer-dashboard",
  DASHBOARD: "",
  OVERVIEW: "fundamental-analysis",
  TECHNICAL_ANALYSIS: "technical-analysis",
  DYNAMIC_GRAPHS: "dynamic-graphs",
  GRAPH_EDITOR: "graph-editor",
  CUSTOMER_PROFILE: "customer-profile",
  // COMPONENTS: "/components",
  METRICS_MANAGEMENT: "metrics",
  REVENUES: "revenues",
  GROSS_PROFITS: "gross-profits",
  NET_PROFITS: "net-profits",
  PE_VALUATIONS: "pe-valuations",
  STOCK_MARKET: "stock-market",
  SECTOR: "sector",
  COMPANY_QUARTER: "company-quarter",
  STOCK_LISTINGS: "stock-listings",
  STOCKS: "stocks/:id",
  USER_MANAGEMENT: "user-management",
  USERS: "users",
  ROLES: "roles",
  ROLE_PERMISSIONS: ":id/permissions",
  NEW_ROLE_PERMISSIONS: "new/permissions",
  ENTITLEMENTS: "entitlements",
  EQUATION_BUILDER: "equation-builder",
  SETTINGS: "settings",
  ADS: "ads",
  SETTINGS_METRICS_TO_ACCOUNTING_TERM: "metrics-to-accounting-term",
  SCREENER: "screener",
  AI_ANALYZE: "ai-analyze",
  STOCK_CHATBOT: "stock-chatbot",
  MANUALLY_CREATED_USER_UPDATE: "user-update",
  WATCHLIST: "watchlist",
  SUPPORT: "support",
  FINANCIALS: "financials",
  ANNUAL_REPORT_EXTRACTION: "annual-report-extraction",
  ANNUAL_REPORT_DATA_ENTRY: "annual-report-data-entry",
  ANNUAL_REPORT_QC: "annual-report-qc",
  ANNUAL_REPORT_MANUAL_ENTRY: "annual-report-manual-entry",
  STOCK_ASSISTANT: "stock-assistant",
  MARKET_HEATMAP: "market-heatmap",
  SINGLE_STOCK_ANALYSIS: "single-stock-analysis",
  BEGINNER: "beginner",
  FALCON_LOG_MONITOR: "falcon-log-monitor",
};

export default ROUTES;

export const HOMEPAGE = "https://valueit.io";
